export default defineNuxtPlugin(() => {
  const isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
  const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

  //自定义JS注册事件监听 connectWebViewJavascriptBridge 方法名可改
  function connectWebViewJavascriptBridge(callback) {
    if (isAndroid) {
      if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge)
      } else {
        document.addEventListener(
          'WebViewJavascriptBridgeReady',
          () => {
            callback(window.WebViewJavascriptBridge)
          },
          false
        )
      }
    }

    if (isiOS) {
      if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge)
      } else if (window.WVJBCallbacks) {
        window.WVJBCallbacks.push(callback)
      } else {
        window.WVJBCallbacks = [callback];
        const WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0)
      }
    }
  }

  //注册回调函数，第一次连接时调用 初始化函数 connectWebViewJavascriptBridge和上面一致
  connectWebViewJavascriptBridge(function (jsbridge) {
    //初始化 必须有 Android 通过 JSBridge 调用 默认JS bridge.init bridgeWebView.send调用
    jsbridge.init(function (message, callback) {
      callback({ 'Javascript Responds': 'Android调用JS初始化方法!' })
    })
  })

  const bridgeClient = {
    get available() {
      return window?.navigator?.userAgent?.includes('th1games')
    },
    registerHandler: function (name, fun) {
      connectWebViewJavascriptBridge(function (jsbridge) {
        //Android调用js方法：functionInJs方法名称需要保持一致 ，并返回给Android通知
        jsbridge.registerHandler(name, function (data, responseCallback) {
          responseCallback(fun(data && JSON.parse(data)))
        })
      })
    },
    callHandler: function (name, data, fun) {
      connectWebViewJavascriptBridge(function (jsbridge) {
        //JS调用Android方法：接收Android传递过来的数据，并做处理
        jsbridge.callHandler(name, JSON.stringify(data), function (data) {
          fun(data && JSON.parse(data))
        })
      })
    },
  }

  return {
    provide: {
      bridge: bridgeClient
    }
  }
})
